export class ClaimTypes {
    public static actor: string =
        'http://schemas.xmlsoap.org/ws/2009/09/identity/claims/actor';
    public static postalCode: string =
        'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/postalcode';
    public static primaryGroupSid: string =
        'http://schemas.microsoft.com/ws/2008/06/identity/claims/primarygroupsid';
    public static primarySid: string =
        'http://schemas.microsoft.com/ws/2008/06/identity/claims/primarysid';
    public static role: string =
        'http://schemas.microsoft.com/ws/2008/06/identity/claims/role';
    public static rsa: string =
        'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/rsa';
    public static serialNumber: string =
        'http://schemas.microsoft.com/ws/2008/06/identity/claims/serialnumber';
    public static sid: string =
        'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/sid';
    public static spn: string =
        'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/spn';
    public static stateOrProvince: string =
        'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/stateorprovince';
    public static streetAddress: string =
        'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/streetaddress';
    public static surname: string =
        'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/surname';
    public static system: string =
        'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/system';
    public static thumbprint: string =
        'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/thumbprint';
    public static upn: string =
        'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/upn';
    public static uri: string =
        'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/uri';
    public static userData: string =
        'http://schemas.microsoft.com/ws/2008/06/identity/claims/userdata';
    public static version: string =
        'http://schemas.microsoft.com/ws/2008/06/identity/claims/version';
    public static webpage: string =
        'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/webpage';
    public static windowsAccountName: string =
        'http://schemas.microsoft.com/ws/2008/06/identity/claims/windowsaccountname';
    public static windowsDeviceClaim: string =
        'http://schemas.microsoft.com/ws/2008/06/identity/claims/windowsdeviceclaim';
    public static windowsDeviceGroup: string =
        'http://schemas.microsoft.com/ws/2008/06/identity/claims/windowsdevicegroup';
    public static windowsFqbnVersion: string =
        'http://schemas.microsoft.com/ws/2008/06/identity/claims/windowsfqbnversion';
    public static windowsSubAuthority: string =
        'http://schemas.microsoft.com/ws/2008/06/identity/claims/windowssubauthority';
    public static otherPhone: string =
        'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/otherphone';
    public static nameIdentifier: string =
        'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier';
    public static username: string =
        'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name';
    public static mobilePhone: string =
        'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/mobilephone';
    public static anonymous: string =
        'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/anonymous';
    public static authentication: string =
        'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/authentication';
    public static authenticationInstant: string =
        'http://schemas.microsoft.com/ws/2008/06/identity/claims/authenticationinstant';
    public static authenticationMethod: string =
        'http://schemas.microsoft.com/ws/2008/06/identity/claims/authenticationmethod';
    public static authorizationDecision: string =
        'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/authorizationdecision';
    public static cookiePath: string =
        'http://schemas.microsoft.com/ws/2008/06/identity/claims/cookiepath';
    public static country: string =
        'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/country';
    public static dateOfBirth: string =
        'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/dateofbirth';
    public static denyOnlyPrimaryGroupSid: string =
        'http://schemas.microsoft.com/ws/2008/06/identity/claims/denyonlyprimarygroupsid';
    public static denyOnlyPrimarySid: string =
        'http://schemas.microsoft.com/ws/2008/06/identity/claims/denyonlyprimarysid';
    public static denyOnlySid: string =
        'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/denyonlysid';
    public static windowsUserClaim: string =
        'http://schemas.microsoft.com/ws/2008/06/identity/claims/windowsuserclaim';
    public static denyOnlyWindowsDeviceGroup: string =
        'http://schemas.microsoft.com/ws/2008/06/identity/claims/denyonlywindowsdevicegroup';
    public static dsa: string =
        'http://schemas.microsoft.com/ws/2008/06/identity/claims/dsa';
    public static email: string =
        'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress';
    public static expiration: string =
        'http://schemas.microsoft.com/ws/2008/06/identity/claims/expiration';
    public static expired: string =
        'http://schemas.microsoft.com/ws/2008/06/identity/claims/expired';
    public static gender: string =
        'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/gender';
    public static givenName: string =
        'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/givenname';
    public static groupSid: string =
        'http://schemas.microsoft.com/ws/2008/06/identity/claims/groupsid';
    public static hash: string =
        'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/hash';
    public static homePhone: string =
        'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/homephone';
    public static isPersistent: string =
        'http://schemas.microsoft.com/ws/2008/06/identity/claims/ispersistent';
    public static locality: string =
        'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/locality';
    public static dns: string =
        'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/dns';
    public static x500DistinguishedName: string =
        'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/x500distinguishedname';

    // Custom claims
    public static practiceId: string = 'practiceid';
    public static practiceUserId: string = 'practiceuserid';
}
